import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

class VerificationError extends Component {
  render() {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <FontAwesomeIcon icon={faCircleXmark} style={styles.icon} />

          <h1 style={styles.title}>Verification Failed</h1>
          <p style={styles.message}>
            Something went wrong during verification. Please try again.
          </p>

          {/* <button style={styles.button} onClick={this.handleRetry}>
            Retry
          </button> */}
        </div>
      </div>
    );
  }

  handleRetry = () => {
    console.log("Retry clicked");
  };
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fa",
  },
  card: {
    padding: "40px",
    borderRadius: "12px",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "400px",
  },
  icon: {
    fontSize: "60px",
    color: "#e74c3c",
    marginBottom: "15px",
  },
  title: {
    margin: "10px 0",
    color: "#e74c3c",
  },
  message: {
    color: "#555",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    background: "#e74c3c",
    color: "#fff",
    cursor: "pointer",
  },
};

export default VerificationError;